import { Container, Graphics, Sprite } from 'pixi.js';
import warningImg from '../assets/warning.png';
export class NodeValid {
  constructor() {
    this.container = this.build();
  }
  build = () => {
    const container = new Container();
    const size = 26;
    const radius = size / 2;
    const innerYellow = new Graphics();
    innerYellow.lineStyle(2, 0xffffff);
    innerYellow.beginFill(0xffaf7d);
    innerYellow.drawCircle(radius, radius, radius);
    innerYellow.endFill();
    this.icon = new Sprite.from(warningImg);
    this.icon.scale.x = 0.37;
    this.icon.scale.y = 0.37;
    this.icon.x = 5.8;
    this.icon.y = 5.7;
    this.icon.alpha = 0.7;
    container.addChild(innerYellow);
    container.addChild(this.icon);
    container.alpha = 0;
    return container;
  };
}